import { slugRequest } from '../slugRequest';
import {
  ingameTestBaseUrl as testUrl,
  ingameBaseUrl as baseUrl,
} from '@/config/api';
import { tokenObj } from '@/js/tokenParams.js';

// 统一红点查询
export function getRedPointList() {
  const path = '/gingame/redpoint/get_red_point';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: true,
    query: {
      game: 'gp',
      bid: 'ingame',
    },
  };

  return slugRequest(config);
}

/**
 * 获取拍脸图的数据
 */
export function getSplashScreenData() {
  const path = '/gingame/push/splash_screen_list';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: true,
    query: {
      game: 'gp',
      partition: tokenObj.platid,
      area: tokenObj.areaid,

    },
  };

  return slugRequest(config);
}

/**
 * 上报拍脸图 浏览和点击数据
 * id: 拍脸图 id
 * behavior: 1 浏览， 2 点击
 */
export function reportSplashScreenBehavior(
  id: string | number,
  behavior: number,
) {
  const path = '/gingame/push/splash_screen_report';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: true,
    query: {
      id,
      behavior_type: behavior,
      game: 'gp',
    },
  };

  return slugRequest(config);
}

/**
 * 获取用户类型，新用户/老用户/回流用户（半年没有来过）
 * @param {*} openid
 */
export function getUserAttributeList(openid: string | number) {
  const path = '/ingamego/trpc/user-data/get_by_game';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: true,
    query: {
      game: 'gp',
      bid: 'ingame',
      id: openid,
    },
  };

  return slugRequest(config);
}

// // 设置用户看过评论引导。i64代表val是int64类型
// export function setI64UserAttribute(openid: string | number, attr: string, value: string | number) {
//   const path = '/ingamego/trpc/user-data/set_i64_by_game';

//   const config: ApiTypes.HttpRequestConfig = {
//     testUrl: `${testUrl}${path}`,
//     baseUrl,
//     path,
//     isAuth: true,
//     source: 'backEnd',
//     type: 'api',
//     method: 'GET',
//     underlizeQuery: true,
//     query: {
//       game: 'gp',
//       bid: 'ingame',
//       openid,
//       attr,
//       value,
//     },
//   };

//   return slugRequest(config);
// }


// note: 保存个人属性信息, 用户描述信息的编辑和获取
export async function setUserAttribute(query: {
  attr: 'intro' | 'gameDataVisible';
  value: string;
}) {
  const path = '/ingamego/trpc/user-data/set_string_by_game';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    underlizeQuery: true,
    method: 'GET',
    query: {
      game: 'gp',
      gameid: 'gp',
      bid: 'ingame',
      ...query,
    },
  };

  return await slugRequest(config);
}

// note: 保存个人属性信息, 用户描述信息的编辑和获取
export async function setUserAttributeBool(query: {
  attr: string;
  value: boolean;
}) {
  const path = '/ingamego/trpc/user-data/set_bool_by_game';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    underlizeQuery: true,
    method: 'GET',
    query: {
      game: 'gp',
      gameid: 'gp',
      bid: 'ingame',
      ...query,
    },
  };

  return await slugRequest(config);
}

// 批量用户属性
export async function batchGetUserAttributeList(ids: string[]) {
  let idStr = '';
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < ids.length; i++) {
    const id = ids[i];
    if (i === 0) {
      idStr += `?ids=${id}`;
    } else {
      idStr += `&ids=${id}`;
    }
  }

  const path = `/ingamego/trpc/user-data/get_many_by_game_eid${idStr}`;

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    underlizeQuery: true,
    method: 'GET',
    data: {
      ids,
    },
    query: {
      game: 'gp',
      gameid: 'gp',
      bid: 'ingame',
    },
  };

  return await slugRequest(config);
}

// 获取music数据
export function getMusicList(pages: string | number) {
  const path = '/php/ingame/fans/query_article_list.php';

  const config: ApiTypes.HttpRequestByJsonpConf = {
    testUrl: `${testUrl}${path}`,
    url: `${baseUrl}${path}`,
    isAuth: true,
    source: 'backEnd',
    type: 'jsonp',
    underlizeQuery: true,
    query: Object.assign({
      gid: 730,
      bid: 'music',
      cid: 321,
      order: 'top',
      page: pages,
      pagesize: 20,
      detail: 1,
    }),
  };

  return slugRequest(config);
}

// 扣除玩家参与活动次数
export function activityDeductTimes(params: any = {}) {
  const path = '/gingame/go_activity/deduct_times';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: true,
    query: Object.assign(
      {
        game: 'gp',
        activity: 'ingame_space',
        way: 'query',
      },
      params,
    ),
  };

  return slugRequest(config);
}
